import React from 'react';

import Navbar from './navbar';

const Header = () => {
  return (
    <header className='top-0 flex h-16 items-center gap-4 border-b px-4 md:px-6 font-display'>
      <Navbar />
    </header>
  );
};
export default Header;
